var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.naviItemsLoaded
    ? _c(
        "section",
        { class: { rsp2CategoryNavi: true, rsp2SubCategory: _vm.isSubNav } },
        [
          _vm.header
            ? _c("h2", { staticClass: "rsp2Header" }, [
                _vm._v(_vm._s(_vm.header))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "rsp2Content" },
            [
              _vm.naviItems.length > 0
                ? _vm._l(_vm.naviItems, function(item, idx) {
                    return _c("CategoryNaviItem", {
                      key: idx,
                      staticClass: "rsp2Item",
                      attrs: {
                        title: item.title,
                        description: item.hoverText,
                        icon: item.icon,
                        url: item.url,
                        showIcon: !_vm.isSubNav,
                        showArrow: _vm.showArrow,
                        size: _vm.isSubNav ? "n" : "n"
                      }
                    })
                  })
                : [
                    _c("li", { staticClass: "rsp2Empty" }, [
                      _vm._v("Diese Inhalte befinden sich noch im Aufbau.")
                    ])
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _vm.servicesUrl
            ? _c("div", { staticClass: "rsp2Action" }, [
                _c(
                  "a",
                  { staticClass: "riButton", attrs: { href: _vm.servicesUrl } },
                  [_vm._v("Alle Services von A-Z")]
                )
              ])
            : _vm._e()
        ]
      )
    : _vm.termNotFound
    ? _c("section", { staticClass: "rsp2NotFound" }, [
        _c("p", [_vm._v("Die Kategorie konnte nicht gefunden werden.")])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }